export { ReportTable } from './core/table'



// WEBPACK FOOTER //
// ./src/components/report-tables/index.js